import {
  VacantePublica,
  VacantesAgrupadas,
  DatosPostulacion,
  ValidacionDuplicado,
  RespuestaServidor,
  ResponseConteos,
  VacanteDetalle,
  EstadoVacantes,
  CapacidadProfesional,
  VacanteCompletaResponse
} from '../types';
import { apiService } from './apiService';

class JobBoardViewService {

  getVacantesPublicas(): VacantesAgrupadas {
    try {
      const data = window.JobBoardViewData?.[0]?.data?.Vacantes?.detalle || [];
      const activas = data.filter((v: VacanteDetalle) => v.status_name === 'EN PROCESO');
      const inactivas = data.filter(
        (v: VacanteDetalle) => v.status_name === 'CERRADA' || v.status_name === 'DESIERTA'
      );

      return { activas, inactivas };
    } catch (err) {
      console.error('Error al obtener vacantes desde window.JobBoardViewData:', err);
      throw new Error('Error al cargar las vacantes disponibles');
    }
  }
  async getVacanteCompleta(vacanteId: string): Promise<VacantePublica> {
    try {
      const result = await apiService.post<{ success: boolean; data: VacanteCompletaResponse[] }>('get_boards_vacant_description', {
        job_board_id: vacanteId
      });
      if (!result.success || !result.data || result.data.length === 0) {
        throw new Error('No se encontraron datos de la vacante');
      }
      const apiData = result.data[0];
      const capacidadesGenerales: CapacidadProfesional[] = apiData.capacidades
        .filter(cap => cap.category_name === 'GEN')
        .map(cap => ({
          nombre: cap.nombre,
          grado_dominio: cap.level_name as 'Esencial' | 'Importante' | 'Muy importante'
        }));
      const capacidadesTecnicas: CapacidadProfesional[] = apiData.capacidades
        .filter(cap => cap.category_name === 'TEC')
        .map(cap => ({
          nombre: cap.nombre,
          grado_dominio: cap.level_name as 'Esencial' | 'Importante' | 'Muy importante'
        }));
      const convocatoriaArchivo = apiData.archivos.find(archivo =>
        archivo.type_file === 'GENERADO' && archivo.file_type === 'PDF'
      );

      const resultadosArchivo = apiData.archivos.filter(archivo =>
        archivo.type_file.includes('GENERADO') &&
        (archivo.file_path.includes('ganadora') || archivo.file_path.includes('desierta'))
      );

      const resultados_pdf = resultadosArchivo[0]?.file_path || '';

      const vacanteTransformada: VacantePublica = {
        job_board_id: apiData.vacante.job_board_id,
        folio_vacante: apiData.vacante.folio_vacante,
        denominacion_tabular: apiData.vacante.denominacion_tabular,
        denominacion_funcional: apiData.vacante.denominacion_funcional,
        gerencia_name: apiData.vacante.gerencia_name,
        principales_funciones: apiData.vacante.principales_funciones,
        escolaridad_minima: apiData.vacante.escolaridad_minima,
        experiencia_laboral: apiData.vacante.experiencia_laboral,
        adicional: apiData.vacante.adicional || '',
        percepcion_bruta: parseFloat(apiData.vacante.percepcion_bruta),
        percepcion_neta: parseFloat(apiData.vacante.percepcion_neta),
        capacidades_tecnicas: apiData.vacante.capacidades_tecnicas,

        fecha_registro_inicio: apiData.vacante.fecha_registro_inicio,
        fecha_registro_fin: apiData.vacante.fecha_registro_fin,
        hora_registro_inicio: apiData.vacante.hora_registro_inicio,
        hora_registro_fin: apiData.vacante.hora_registro_fin,
        fecha_evaluacion_tecnica_inicio: apiData.vacante.fecha_evaluacion_tecnica_inicio,
        fecha_evaluacion_tecnica_fin: apiData.vacante.fecha_evaluacion_tecnica_fin,
        hora_evaluacion_tecnica_inicio: apiData.vacante.hora_evaluacion_tecnica_inicio,
        hora_evaluacion_tecnica_fin: apiData.vacante.hora_evaluacion_tecnica_fin,
        fecha_evaluacion_psicometrica_inicio: apiData.vacante.fecha_evaluacion_psicometrica_inicio,
        fecha_evaluacion_psicometrica_fin: apiData.vacante.fecha_evaluacion_psicometrica_fin,
        hora_evaluacion_psicometrica_inicio: apiData.vacante.hora_evaluacion_psicometrica_inicio,
        hora_evaluacion_psicometrica_fin: apiData.vacante.hora_evaluacion_psicometrica_fin,
        fecha_verificacion_referencias_inicio: apiData.vacante.fecha_verificacion_referencias_inicio,
        fecha_verificacion_referencias_fin: apiData.vacante.fecha_verificacion_referencias_fin,
        hora_verificacion_referencias_inicio: apiData.vacante.hora_verificacion_referencias_inicio,
        hora_verificacion_referencias_fin: apiData.vacante.hora_verificacion_referencias_fin,
        fecha_entrevista_inicio: apiData.vacante.fecha_entrevista_inicio,
        fecha_entrevista_fin: apiData.vacante.fecha_entrevista_fin,
        hora_entrevista_inicio: apiData.vacante.hora_entrevista_inicio,
        hora_entrevista_fin: apiData.vacante.hora_entrevista_fin,
        fecha_resultados_inicio: apiData.vacante.fecha_resultados_inicio,
        fecha_resultados_fin: apiData.vacante.fecha_resultados_fin,
        hora_resultados_inicio: apiData.vacante.hora_resultados_inicio,
        hora_resultados_fin: apiData.vacante.hora_resultados_fin,

        ponderacion_evaluacion_tecnica: parseInt(apiData.vacante.ponderacion_evaluacion_tecnica),
        ponderacion_psicometrica: parseInt(apiData.vacante.ponderacion_psicometrica),
        ponderacion_entrevista: parseInt(apiData.vacante.ponderacion_entrevista),

        capacidades_generales: capacidadesGenerales,
        capacidades_tecnicas_profesionales: capacidadesTecnicas,

        status_name: apiData.vacante.status_name as 'EN PROCESO' | 'CERRADA' | 'DESIERTA',
        fase_actual: '',
        convocatoria_pdf: convocatoriaArchivo?.file_path,
        resultados_pdf: resultados_pdf,
        created_at: apiData.vacante.created_at,
        updated_at: apiData.vacante.updated_at || apiData.vacante.created_at
      };

      return vacanteTransformada;
    } catch (err) {
      console.error('Error al obtener vacante completa:', err);
      throw new Error('No se pudo cargar la información completa de la vacante');
    }
  }
  getConteoVacantes(): ResponseConteos {
    try {
      const windowData = window.JobBoardViewData?.[0]?.data?.Vacantes;

      return {
        detalle: windowData?.detalle || [],
        totales_por_estado: windowData?.totales_por_estado || []
      };
    } catch (err) {
      console.error('Error al obtener conteos desde window.JobBoardViewData:', err);
      throw new Error('Error al cargar los conteos de vacantes');
    }
  }
  getVacantesActivas(): VacanteDetalle[] {
    const { activas } = this.getVacantesPublicas();
    return activas;
  }
  getVacantesInactivas(): VacanteDetalle[] {
    const { inactivas } = this.getVacantesPublicas();
    return inactivas;
  }
  async validarDuplicado(
    jobBoardId: string,
    nombreCompleto: string,
    fechaNacimiento: string
  ): Promise<ValidacionDuplicado> {
    try {
      const result = await apiService.post<{ data: ValidacionDuplicado }>('duplicate_vacancy', {
        job_board_id: jobBoardId,
        nombre_completo: nombreCompleto,
        fecha_nacimiento: fechaNacimiento
      });

      return result.data || { existe_duplicado: false, mensaje: '' };
    } catch (err) {
      console.error('Error al validar duplicado:', err);
      throw new Error('Error al validar la postulación');
    }
  }
  async enviarPostulacion(datos: DatosPostulacion): Promise<RespuestaServidor> {
    try {
      const validacion = await this.validarDuplicado(
        datos.job_board_id,
        datos.nombre_completo,
        datos.fecha_nacimiento
      );

      if (validacion.existe_duplicado) {
        return {
          success: false,
          message: validacion.mensaje || 'Ya te encuentras postulado(a) para esta vacante'
        };
      }
      const result = await apiService.post('create_vacancy', datos);

      return {
        success: result.success,
        message: result.message || 'Postulación enviada correctamente'
      };
    } catch (err) {
      console.error('Error al enviar postulación:', err);
      throw new Error('Error al procesar tu postulación');
    }
  }
  async refreshVacantesData(): Promise<void> {
    try {
      const result = await apiService.post<{ data: { Vacantes: { detalle: VacanteDetalle[], totales_por_estado: EstadoVacantes[] } } }>('get_boards_vacant_counts');
      if (window.JobBoardViewData?.[0]?.data) {
        window.JobBoardViewData[0].data = {
          ...window.JobBoardViewData[0].data,
          ...result.data
        };
      }
    } catch (err) {
      console.error('Error al refrescar datos:', err);
      throw new Error('Error al actualizar los datos');
    }
  }
  calcularFaseActual = (vacante: VacantePublica): string => {
    const ahora = new Date();

    const yyyy = ahora.getFullYear();
    const mm = String(ahora.getMonth() + 1).padStart(2, '0');
    const dd = String(ahora.getDate()).padStart(2, '0');
    const fechaActual = `${yyyy}-${mm}-${dd}`; 
    const horaActual =
      ahora.getHours().toString().padStart(2, '0') + ':' +
      ahora.getMinutes().toString().padStart(2, '0');

    const estaEnRango = (
      fechaInicio: string,
      fechaFin: string,
      horaInicio: string,
      horaFin: string
    ): boolean => {
      if (fechaActual < fechaInicio || fechaActual > fechaFin) return false;
      if (fechaActual === fechaInicio && horaActual < horaInicio) return false;
      if (fechaActual === fechaFin && horaActual > horaFin) return false;
      return true;
    };

    if (estaEnRango(
      vacante.fecha_registro_inicio,
      vacante.fecha_registro_fin,
      vacante.hora_registro_inicio,
      vacante.hora_registro_fin
    )) return 'Registro';

    if (estaEnRango(
      vacante.fecha_evaluacion_tecnica_inicio,
      vacante.fecha_evaluacion_tecnica_fin,
      vacante.hora_evaluacion_tecnica_inicio,
      vacante.hora_evaluacion_tecnica_fin
    )) return 'Evaluación técnica';

    if (estaEnRango(
      vacante.fecha_evaluacion_psicometrica_inicio,
      vacante.fecha_evaluacion_psicometrica_fin,
      vacante.hora_evaluacion_psicometrica_inicio,
      vacante.hora_evaluacion_psicometrica_fin
    )) return 'Evaluación psicométrica';

    if (estaEnRango(
      vacante.fecha_verificacion_referencias_inicio,
      vacante.fecha_verificacion_referencias_fin,
      vacante.hora_verificacion_referencias_inicio,
      vacante.hora_verificacion_referencias_fin
    )) return 'Verificación de referencias';

    if (estaEnRango(
      vacante.fecha_entrevista_inicio,
      vacante.fecha_entrevista_fin,
      vacante.hora_entrevista_inicio,
      vacante.hora_entrevista_fin
    )) return 'Entrevista';

    if (estaEnRango(
      vacante.fecha_resultados_inicio,
      vacante.fecha_resultados_fin,
      vacante.hora_resultados_inicio,
      vacante.hora_resultados_fin
    )) return 'Resultados';

    return 'Próximamente';
  };


  formatearFecha = (fecha: string): string => {
    const [year, month, day] = fecha.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  formatearSalario = (cantidad: number): string => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(cantidad);
  };
}

export const jobBoardViewService = new JobBoardViewService();